module.exports = __webpack_public_path__ + "img/ser-um-afiliado.2ed46f4d.webp";